import { createTranslationKeysObject } from '@utility/checkout-utils';

import { enGb } from '../translations/en-gb';

export const TRANSLATION_KEYS = createTranslationKeysObject(enGb);
